/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { useEffect, useState } from "react";
import { Button, Paper, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Grid } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
import axios from "../../utils/axios-instance/AxiosInstance";
import { ConfigurationVariables } from "../../config";
import TextInputField from "../../utils/text-input-field/TextInputField";
import AcceptTerms from "../../utils/accept-terms/AcceptTerms";
import { PrimaryBtn, TextBtn } from "../../utils/buttons/Buttons";
import "./CreateUser.scss";
import ConfirmModal from "../../utils/modals/confirm-modal/ConfirmModal";
import InfoModal from "../../utils/modals/info-modal/InfoModal";
import Loader from "../Loader/Loader";
import UploadProfilePic from "../../utils/upload-profile-pic/UploadProfilePic";
import AutoCompleteMultiSelect from "../../utils/multiselect-dropdown/AutoCompleteMultiSelect";
import { IErrorProps } from "../../models";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import getErrorForUserPages from "../../utils/methods/getErrorForUserPages";
import { getAccessToken } from "../../utils";
import classes from "./CreateUser.module.css";

function CreateTenantPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [roleOptions, setRoleOptions] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [roleId, setRoleIds] = useState<string[]>([]);
  const [userProfilePic, setUserProfilePic] = useState<any>();
  const [isFirstNameValid, setIsFirstNameValid] = useState<boolean>(true);
  const [islastNameValid, setIslastNameValid] = useState<boolean>(true);
  const [isFirstNameEmpty, setIsFirstNameEmpty] = useState<boolean>(false);
  const [isLastNameEmpty, setIsLastNameEmpty] = useState<boolean>(false);
  const [isEmailIdEmpty, setIsEmailIdEmpty] = useState<boolean>(false);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [isRoleIdEmpty, setIsRoleIdEmpty] = useState<boolean>(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);

  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const firstNameRegex = /^[a-zA-Z\s]*$/;
  const lastNameRegex = /^[a-zA-Z\s]*$/;
  const { UserMgmt_Endpoints, Api, Version, UserController } =
    ConfigurationVariables;
  let usersUrl = `${UserMgmt_Endpoints}/${Api}/${Version}/${UserController}`;
  const rolesUrl = `${usersUrl}/roles`;
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const headers = {
    customerId: location?.state?.tenantID,
    accept: "application/json",
    Authorization: `Bearer ${getAccessToken()}`,
  };
  /** Effect to set errro dialog or error toastbar state to open */
  useEffect(() => {
    if (
      errorList.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (
      errorList.some((x) => x.errorCode === 400 || x.errorCode === 409) &&
      !openToastError
    ) {
      setOpenToastError(true);
    }
    if (
      errorList.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== 409 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
  }, [errorList]);

  /**To get roles available and render assign roles dropdown */
  useEffect(() => {
    setLoading(true);
    axios
      .get(rolesUrl, {
        headers: {
          ...headers,
        },
      })
      .then((response) => {
        setIsRoleIdEmpty(false);
        setRoleOptions(
          response?.data?.map((obj: any) => {
            return {
              label: obj?.name ?? "",
              value: obj?.roleId ?? "",
              ...obj,
            };
          })
        );
      })
      .catch((error) => {
        setLoading(false);
        setErrorModal(true);
        setErrorMsg(error?.message);
        let newError: IErrorProps = getErrorForUserPages(error);
        setErrorList((prevState) => [...prevState, newError]);
      })
      .finally(() => setLoading(false));
  }, []);

  const cancelBtnHandler = () => {
    setConfirmModal(false);
    navigate(-1);
  };

  /**
   * Checks if the first name, last name, email and roled id entered
   * @returns boolean - returns fasle if any field is missing
   */
  let hasAllFieldsInput = () => {
    if (firstName && lastName && emailId && roleId.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Checks if the first name, last, email id is valid or not
   * @returns boolean - returns false if any field is invalid.
   */
  const isInputValid = () => {
    if (isFirstNameValid && islastNameValid && isEmailValid) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * To display helper text
   * Setting true  in state if any field is empty
   */
  const checkFieldEmpty = () => {
    !firstName && setIsFirstNameEmpty(true);
    !lastName && setIsLastNameEmpty(true);
    !emailId && setIsEmailIdEmpty(true);
    !roleId && setIsRoleIdEmpty(true);
    roleId?.length == 0 && setIsRoleIdEmpty(true);
  };

  /**
   * @summery
   * input fields validation: empty field check
   * email basic validation
   * opens confirm modal if all mandatory fields entered
   */
  const createBtnHandler = () => {
    checkFieldEmpty();

    if (hasAllFieldsInput() && !isTermsAccepted) {
      setIsFormFilled(true);
      setIsTermsAccepted(false);
    }
    if (!emailRegex.test(emailId)) {
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }

    // checking if all mandatory fields are filled and open confirm modal
    if (hasAllFieldsInput() && isInputValid() && isTermsAccepted) {
      setConfirmModal(true);
    }
  };

  /**
   *
   * Saving user in database on click confirm create btn
   */
  const confirmCreateHandler = () => {
    setConfirmModal(false);
    setErrorModal(false);
    setLoading(true);
    setOpenToastError(false);

    let reqBody = {
      firstName: firstName,
      lastName: lastName,
      emailId: emailId,
      roleId: roleId,
    };

    /**Creating new user in data base */
    axios
      .post(usersUrl, reqBody, {
        headers: {
          ...headers,
        },
      })
      .then((response) => {
        setLoading(false);

        /** Upload User Profile Pic to database*/
        let userId = response?.data?.userId;
        let uploadProfilePicUrl = `${usersUrl}/userpic/${userId}`;
        let formData = new FormData();
        formData.append("logo", userProfilePic);

        /**Saving profile pic only if the user uploads  */
        if (userProfilePic) {
          setLoading(true);
          axios
            .put(uploadProfilePicUrl, formData, {
              headers: {
                ...headers,
              },
            })
            .then((response) => {
              setLoading(false);
              setSuccessModal(true);
            })
            .catch((error) => {
              setLoading(false);
              setErrorModal(true);
              setErrorMsg(error?.message);

              let newError: IErrorProps = getErrorForUserPages(error);
              setErrorList((prevState) => [...prevState, newError]);
            });
        } else {
          setLoading(false);
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorModal(true);
        setErrorMsg(error?.message);
        let newError: IErrorProps = getErrorForUserPages(error);
        setErrorList((prevState) => [...prevState, newError]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getEmailHelperText = () => {
    let helperText = "";
    if (isEmailIdEmpty) {
      helperText = "Please enter an email address";
    }
    if (!isEmailValid && !isEmailIdEmpty) {
      helperText = "Please enter a valid email address";
    }
    return helperText;
  };

  const getFirstNameHelperText = () => {
    let helperText = "";
    if (isFirstNameEmpty) {
      helperText = "Please enter First name";
    }
    if (!isFirstNameEmpty && !isFirstNameValid) {
      helperText = "First name can only contain alphabets";
    }
    return helperText;
  };

  const getLastNameHelperText = () => {
    let helperText = "";
    if (isLastNameEmpty) {
      helperText = "Please enter Last name ";
    }
    if (!isLastNameEmpty && !islastNameValid) {
      helperText = "Last name can only contain alphabets";
    }
    return helperText;
  };

  /**
   *
   * @param event
   * @param values selected values - list of objects
   * @param reason
   *
   * sets the selected options in the state
   */
  const assignRolesHandler = (event: any, values: any[], reason: string) => {
    const selectedRoles = values && values.map((obj) => obj.value);

    setRoleIds(selectedRoles);
    selectedRoles?.length > 0 && setIsRoleIdEmpty(false);
  };

  // Error handling handlers
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // End error handling handlers
  return (
    <div className="create-user-dashboard">
      <Paper className="paper">
        <Grid container direction="row" p={1} className="grid-Heading">
          <Grid
            item
            xs={12}
            sx={{ paddingBottom: 1, display: "flex", flexDirection: "row" }}
          >
            <Button
              onClick={() => {
                navigate(-1);
              }}
              sx={{
                color: "#F0F0F0",
                padding: "0vh 0vh 0.7vh 0vh",
                fontSize: "1.1 rem",
                justifyContent: "start",
                minWidth: "1vw",
                minHeight: "0.5vh",
              }}
            >
              <ArrowBackIosIcon
                data-testid="arrow-back-icon"
                sx={{ fontSize: "0.9 rem" }}
              />
            </Button>
            <Typography className="mainheading">Create New User </Typography>
          </Grid>
          <Grid
            container
            direction="column"
            sx={{
              height: "30vh",
              backgroundColor: "#272727",
              minWidth: "850px",
              minHeight: "200px",
              width: "99%",
              border: "1px solid #101010",
              boxShadow:
                "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
            }}
          >
            <Grid
              item
              sx={{
                height: "20%",
                background: "#272727",
              }}
            >
              <Typography className={classes.secondaryHeading}>
                PROFILE INFORMATION
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                height: "80%",
              }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <Grid
                  item
                  sx={{
                    width: "18%",
                    minHeight: "120px",
                    minWidth: "120px",
                  }}
                >
                  <UploadProfilePic
                    profilePic=""
                    onImageUpload={(image) => {
                      setUserProfilePic(image);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    width: "80%",
                    display: "flex",
                  }}
                >
                  <Grid
                    sx={{
                      width: "50%",
                      padding: "1%",
                    }}
                  >
                    <TextInputField
                      fieldLabel="First Name"
                      id="FirstName"
                      type="text"
                      required={true}
                      placeholder="Enter"
                      onChange={(value) => {
                        setFirstName(value);
                        setIsFirstNameEmpty(false);
                        firstNameRegex.test(value)
                          ? setIsFirstNameValid(true)
                          : setIsFirstNameValid(false);
                      }}
                      error={isFirstNameEmpty || !isFirstNameValid}
                      helperText={getFirstNameHelperText()}
                      styleName="text-input-field"
                      dataTestId="firstName"
                    />
                    <TextInputField
                      fieldLabel="Email ID"
                      id="EmailID"
                      type="text"
                      required={true}
                      styleName="text-input-field"
                      placeholder="Enter"
                      onChange={(value) => {
                        setEmailId(value);
                        setIsEmailIdEmpty(false);
                        emailRegex.test(value)
                          ? setIsEmailValid(true)
                          : setIsEmailValid(false);
                      }}
                      error={isEmailIdEmpty || !isEmailValid}
                      helperText={getEmailHelperText()}
                      dataTestId="emailId"
                    />{" "}
                  </Grid>
                  <Grid
                    sx={{
                      width: "50%",
                      padding: "1%",
                    }}
                  >
                    <TextInputField
                      fieldLabel="Last Name"
                      id="LastName"
                      type="text"
                      styleName="text-input-field"
                      dataTestId="lastName"
                      required={true}
                      placeholder="Enter"
                      onChange={(value) => {
                        setLastName(value);
                        setIsLastNameEmpty(false);
                        lastNameRegex.test(value)
                          ? setIslastNameValid(true)
                          : setIslastNameValid(false);
                      }}
                      error={isLastNameEmpty || !islastNameValid}
                      helperText={getLastNameHelperText()}
                    />
                    <AutoCompleteMultiSelect
                      label="Assign Roles"
                      required
                      options={roleOptions}
                      onChange={assignRolesHandler}
                      hasError={isRoleIdEmpty}
                      helperText={isRoleIdEmpty ? "Please select roles" : ""}
                      selectAllLabel={"Select all"}
                    />{" "}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Accept terms and conditions checkbox with text********************** */}

          <AcceptTerms
            isFormFilled={isFormFilled}
            isTermsAccepted={isTermsAccepted}
            onTermsAccept={(event) => {
              setIsTermsAccepted(event?.target.checked);
            }}
          />
        </Grid>
      </Paper>
      {/* cancel and create buttons************************************************** */}

      <Grid
        item
        xs={12}
        sx={{
          backgroundColor: "#272727",
          width: "98%",
          border: "1px solid #101010",
          boxShadow:
            "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
          display: "flex",
          position: "fixed",
          bottom: 1,
          height: "8vh",
        }}
      >
        <Grid sx={{ height: "3vh", margin: "0.5vh" }}>
          <Button
            color="primary"
            fullWidth
            sx={{
              height: "1vh",
              margin: "1vw",
              position: "relative",
            }}
            className="cancelButton"
            onClick={() => cancelBtnHandler()}
          >
            Cancel
          </Button>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          sx={{ height: "3vh", paddingRight: "1.5vw", margin: "0.5vh" }}
        >
          <Button
            sx={{
              padding: 2,
              height: "1vh",
              position: "relative",
              margin: "0.5vw",
            }}
            className="createButton"
            variant="contained"
            onClick={createBtnHandler}
          >
            Create{" "}
          </Button>
        </Grid>
      </Grid>
      {/* <div className="cancel-create-btns-box">
        <TextBtn btnText="Cancel" onClick={() => cancelBtnHandler()} />
        <div style={{ marginLeft: "auto" }}>
          <PrimaryBtn btnText="Create" onClick={createBtnHandler} />
        </div>
      </div> */}
      {loading && <Loader />}
      <ConfirmModal
        dialogTitle="Create User"
        dialogContentText="Do you want to create this user?"
        onConfirmClick={confirmCreateHandler}
        onCancelClick={() => setConfirmModal(false)}
        onCloseClick={() => setConfirmModal(false)}
        open={confirmModal}
      />
      <InfoModal
        dialogTitle="Successfully Created"
        dialogContentText="User Account has been created, will be reflected within a minute on page refresh and sent an e-mail notification successfully."
        onOkClick={() => {
          setSuccessModal(false);
          navigate(-1);
        }}
        open={successModal}
      />
      {openDialogServerError && (
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}
      {openDialogNoURLError && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList}
        />
      )}
      {/* /// End error handling logic */}
    </div>
  );
}

export default CreateTenantPage;
